var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useState } from "react";
import Input from "../input/Input";
import { useDebouncedCallback } from "../../hooks/useDebounceCallback";
import useUniqueId from "../../hooks/useUniqueId";
const prefixId = "nx-search-";
const Search = forwardRef(function Search(_a, ref) {
    var { id, onSearch, wait = 0, initialValue } = _a, rest = __rest(_a, ["id", "onSearch", "wait", "initialValue"]);
    id = useUniqueId(prefixId, id);
    const [inputValue, setInputValue] = useState(initialValue || "");
    const debounceSearch = onSearch && useDebouncedCallback(onSearch, wait);
    const handleInputChange = (e) => {
        setInputValue(e.target.value);
        if (debounceSearch) {
            debounceSearch(e.target.value);
        }
    };
    const handleInputPressEnter = () => {
        if (onSearch) {
            onSearch(inputValue);
        }
    };
    return (React.createElement(Input, Object.assign({ ref: ref, id: id, value: inputValue, onChange: handleInputChange, onPressEnter: handleInputPressEnter, prefix: "searchSmall" }, rest)));
});
export default Search;
//# sourceMappingURL=Search.js.map